import React from "react";
import { Button, Grid, Typography } from "@sumprio/ui";

const separatorStyle = { color: "var(--color-border-neutral-secondary, #292D35)" };

export interface BulkActionConfig {
  label: string;
  onClick: () => void;
  variant?: "brand-tertiaryColor" | "danger-tertiary";
}

interface BulkActionBarProps {
  selectedCount: number;
  actions: BulkActionConfig[];
}

export default function BulkActionBar({ selectedCount, actions }: BulkActionBarProps) {
  if (selectedCount === 0) return null;

  return (
    <Grid display="flex" alignItems="center" gap="md">
      <Typography variant="body" bodySize="sm" bodyWeight="regular">
        {selectedCount} selected
      </Typography>
      {actions.map((action, index) => (
        <React.Fragment key={index}>
          <Typography variant="body" bodySize="sm" bodyWeight="regular" style={separatorStyle}>
            |
          </Typography>
          <Button
            variant={action.variant ?? "brand-tertiaryColor"}
            size="xs"
            onClick={action.onClick}
          >
            {action.label}
          </Button>
        </React.Fragment>
      ))}
    </Grid>
  );
}
